import defaultSettings from './defaultSettings';

export const leadingZeros = (num, count) => {
    return num.length < count ? leadingZeros(`0${num}`, count) : num;
};

export const getPathOfStatic = (relativePath) => {
    // const pathToStaticFolder = window['staticFolder'] ? window['staticFolder'] : '/static';
    const pathToStaticFolder = '';
    return pathToStaticFolder + relativePath;
};

export const resetSettings = () => {
    window.localStorage.removeItem('abacus-settings');
    window.location.reload();
};

export const getSettings = (name) => {
    if (window.localStorage.getItem('abacus-settings') == null) {
        window.localStorage.setItem('abacus-settings', JSON.stringify(defaultSettings));
    }
    try {
        /* eslint no-unused-vars: 0*/
        const settings = JSON.parse(window.localStorage.getItem('abacus-settings'));
        /* eslint no-eval: 0 */
        return eval('settings.' + name);
    } catch (e) {
        try {
            /* eslint no-eval: 0 */
            return eval('defaultSettings.' + name);
        } catch (u) {
            console.warn(e);
            return null;
        }
    }
};
const ruNum =[
    ['ноль'],
    ['', 'один', 'два', 'три', 'четыре', 'пять', 'шесть', 'семь', 'восемь', 'девять'],
    ['десять', 'одиннадцать', 'двенадцать', 'тринадцать', 'четырнадцать', 'пятнадцать', 'шестнадцать', 'семнадцать', 'восемнадцать', 'девятнадцать'],
    ['', '', 'двадцать', 'тридцать', 'сорок', 'пятьдесят', 'шестьдесят', 'семьдесят', 'восемьдесят', 'девяносто'],
    ['', 'сто', 'двести', 'триста', 'четыреста', 'пятьсот', 'шестьсот', 'семьсот', 'восемьсот', 'девятьсот']
];

const enNum = [
    ['zero'],
    ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'],
    ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'],
    ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'],
    ['', 'one hundred', 'two hundred', 'three hundred', 'four hundred', 'five hundred', 'six hundred', 'seven hundred', 'eight hundred', 'nine hundred']
];

const tell_number = (num, lang) => {
    const m = lang === 'ru' ? ruNum : enNum;
    if (num === 0) return m[0][0];
    if (num > 999) return '';
    const o = [];

    const asArray = leadingZeros(num, 3).split('');
    for(let i = 0; i < asArray.length; i++){
        o[i] = i === 1 && Number(asArray[i]) === 1 ?
            m[2][asArray[i + 1]] :
            i === 2 ? (Number(asArray[i - 1]) === 1 ?
                '' :
                m[1][asArray[i]]) :
                m[4 - i][asArray[i]];
    }

    return o.filter(a => a !== '').join("\t");
};

export const convertNumberToWords = (number, lang) => {
    return tell_number(number + '', lang).split('\t');
};

export const setSettings = (name, value) => {
    try {
        let settings = window.localStorage.getItem('abacus-settings') == null ? defaultSettings :
            JSON.parse(window.localStorage.getItem('abacus-settings'));
        /* eslint no-eval: 0 */
        eval('settings.' + name + ' = value');
        window.localStorage.setItem('abacus-settings', JSON.stringify(settings));
        return settings;
    } catch (e) {
        console.warn(e);
        return null;
    }
};